// extracted by mini-css-extract-plugin
export default {"section":"HomeSection_section__xuwQG","container":"HomeSection_container__Ql25-"};